import { logger, LogEntity } from '@fiverr-private/obs';
import { getContext } from '@fiverr-private/fiverr_context';

export interface LogClientErrorOptions extends Record<string, unknown> {
    error: LogEntity;
    description?: string;
    requestUrl?: string;
    requestPayload?: Record<string, unknown>;
}

/**
 * Logs a contextualized error.
 * This method is intended for *client* usages.
 */
export const logClientError = ({ error, ...enrichment }: LogClientErrorOptions) => {
    logger.error(error, {
        context: getContext(),
        ...enrichment,
    });
};
